import { createSignal } from "solid-js";
import type { ItineraryPlan } from "../itinerary";
import { loadFollowed, saveFollowed } from "./followed";

// The itinerary picked in the C1 list (shown by C1b), and the one being followed once its bike is
// booked (C5 banner, C7 parking target), kept on the device.
const [chosen, setChosen] = createSignal<ItineraryPlan>();
const [followed, setFollowed] = createSignal<ItineraryPlan | undefined>(loadFollowed());

export const tripPlan = {
  chosen,
  choose: setChosen,
  followed,
  /** Follow `plan` (or stop following with undefined). */
  follow(plan: ItineraryPlan | undefined) {
    saveFollowed(plan);
    setFollowed(plan);
  },
  /** The followed plan when it is about this vehicle (a booking or a ride on another bike: none). */
  followedFor(vehicleId: string | undefined) {
    const p = followed();
    return p && vehicleId && p.bike.vehicleId === vehicleId ? p : undefined;
  },
};
